import { Leaf, X } from '@phosphor-icons/react';

import { SideDrawer, SideDrawerClose, SideDrawerContent } from '../common/SideDrawer';
import pt from '../../locales/pt';
import { AppNavLogout } from './AppNavLogout';
import { NavSectionList } from './NavSection';

/**
 * Drawer de navegação partilhado pela bottom bar (mobile) e pelo rail (tablet)
 * — instância `ds/overlay/side-drawer · nav` no .pen: painel de 340px, header
 * com marca + fechar, corpo com as secções de navegação e rodapé com Sair.
 */
export function AppNavDrawer({ id, open, onOpenChange, sections }) {
  return (
    <SideDrawer open={open} onOpenChange={onOpenChange}>
      <SideDrawerContent
        id={id}
        aria-label={pt.nav.menu}
        // eslint-disable-next-line no-restricted-syntax -- painel de 340px do .pen, sem token de largura
        className="w-[min(100%,21.25rem)]"
        contentClassName="px-space-3 py-space-2"
        header={
          <>
            <span className="flex items-center gap-space-2">
              <Leaf className="h-6 w-6 shrink-0 text-sage-on-tint" aria-hidden />
              <span className="font-display text-type-display-stat font-bold text-foreground">
                {pt.app.name}
              </span>
            </span>
            <SideDrawerClose
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-full bg-muted text-muted-foreground transition-colors hover:text-foreground"
              aria-label="Fechar"
            >
              <X className="h-4 w-4" aria-hidden />
            </SideDrawerClose>
          </>
        }
        footer={
          <AppNavLogout
            compact
            className="gap-space-2 rounded-ds-md px-space-3 py-space-2 text-type-body-sm font-normal"
            onAfterLogout={() => onOpenChange(false)}
          />
        }
      >
        <NavSectionList
          sections={sections}
          variant="drawer"
          onNavigate={() => onOpenChange(false)}
        />
      </SideDrawerContent>
    </SideDrawer>
  );
}

export default AppNavDrawer;
